import { observer } from "mobx-react-lite";
import {
  MyButton,
  MyFileUpload,
  MyModal,
  MySelect,
} from "../../../components/Commons";
import { COMMON } from "../../../constants/commonText.constants";
import { useTran } from "../../../hooks/useTran";
import { useBatchUploadStore } from "../../BatchUpload/useBatchUploadStore";
import { Download } from "lucide-react";
import { useCompanyStore } from "../hooks/useCompanyStore";
import { useEffect, useState } from "react";
import { useExternalSupportStore } from "../../ExternalSupport/hooks/useExternalSupportStore";

const BatchUploadModal = observer(() => {
  const { t } = useTran();
  const { isBatchUploadModalOpen, setIsBatchUploadModalOpen, getCompanies } =
    useCompanyStore();
  const {
    selectedFile,
    setSelectedFile,
    downloadTemplate,
    moduleList,
    setSelectedModule,
    selectedModule,
    uploadBatch,
    handleCloseAndClear,
  } = useBatchUploadStore();

  const { getESPrograms } = useExternalSupportStore();

  useEffect(() => {
    setSelectedModule("company");
  }, []);

  const [loading, setLoading] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const _handleClose = () => {
    setIsBatchUploadModalOpen(false);
    handleCloseAndClear();
  };

  const _handleUpload = async () => {
    setLoading(true);

    const { endpoint, key } = selectedModule;

    const success = await uploadBatch(endpoint);
    if (success) {
      setIsBatchUploadModalOpen(false);
      if (key === "company") {
        await getCompanies();
      } else if (key === "es_program") {
        await getESPrograms();
      }
    }
    setTimeout(() => setLoading(false), 800);
  };

  const _handleDownload = async () => {
    setDownloadLoading(true);
    await downloadTemplate(selectedModule?.endpoint);
    setTimeout(() => setDownloadLoading(false), 800);
  };

  return (
    <MyModal
      isOpen={isBatchUploadModalOpen}
      onClose={_handleClose}
      title={
        <div className="font-medium flex items-center justify-between">
          {selectedModule.key === "es_program" ? (
            <p>{t("External Support Program")}</p>
          ) : (
            <MySelect
              id="batchUploadBtn"
              options={moduleList}
              value={selectedModule.key}
              onChange={(e) => setSelectedModule(e.target.value)}
            />
          )}
          {selectedModule && (
            <MyButton
              size="sm"
              onClick={_handleDownload}
              loading={downloadLoading}
            >
              <Download size={16} className="me-1" />
              {t("Template")}
            </MyButton>
          )}
        </div>
      }
      size={"medium"}
      isStatic
      footer={
        <div className="flex gap-2 items-center justify-end">
          <MyButton variant="outline" onClick={_handleClose}>
            {t(COMMON.CANCEL)}
          </MyButton>
          <MyButton loading={loading} onClick={_handleUpload}>
            {t("Upload")}
          </MyButton>
        </div>
      }
    >
      <div className="flex flex-col min-h-0 overflow-y-auto gap-y-4">
        <MyFileUpload
          onChange={setSelectedFile}
          value={selectedFile}
          acceptedFileTypes=".xlsx"
          isMulti={false}
        />
      </div>
    </MyModal>
  );
});

export default BatchUploadModal;
